<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="primary" style="font-weight:bold; color:white">Update websites</v-card-title>
    <v-card-text>Export to websites started for {{huis.huis_code}}, it will take about 5 minutes before the websites are updated</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huis_encrid: null,
      huis: {}
    }
  },
  methods: {
    open(huis_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/updateWebsites.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updateWebsites"
          },
          updateWebsites: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            this.huis = res.data.updateWebsites;
          }
        })
    }
  }
}
</script>



